require('./ibanModal.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ commons
const { FormattedText } = require('core/i18n').i18n;
const OKModal = require('components/commons/OKModal/OKModal');

const IbanModal = props => {
    const { immIbanModal, onRequestClose } = props;
    const isOpen = immIbanModal.get('isOpen');

    const content = (
        <React.Fragment>
            <FormattedText value="whatIsIBAN-initials" className="iban-modal__title"/>
            <FormattedText value="whatIsIBAN-whatIs" className="iban-modal__text iban-modal__text--first"/>
            <FormattedText value="whatIsIBAN-advantagesSubtitle" className="iban-modal__subtitle"/>
            <FormattedText value="whatIsIBAN-advantagesContent" className="iban-modal__text"/>
            <FormattedText value="whatIsIBAN-formatSubtitle" className="iban-modal__subtitle"/>
            <FormattedText value="whatIsIBAN-formatContent" className="iban-modal__text"/>
        </React.Fragment>
    );
    return (
        <OKModal
            content={content}
            isOpen={isOpen}
            onCloseCallback={onRequestClose}
        />
    )
};

IbanModal.propTypes = {
    immIbanModal: PropTypes.object.isRequired,
    onRequestClose: PropTypes.func.isRequired
};

module.exports.constructor = IbanModal;
module.exports.IbanModal = connect(
    state => ({
        immIbanModal: state.ibanModal
    }))(IbanModal);